const success = {
  path: 'accessPay/success',
  component: resolve => require(['@/pages/admin/reviewed/wechat/accessPay/success'], resolve),
  meta: {isAccessPay: true}
}

export default success
